import {
  TowingEligibleClient,
  TowingNotificationRequest,
  TowingNotificationPreview,
  SendNotificationsResponse,
  WEFResponse
} from '../Types';
import api from '../configs/api.config';

export const getTowingEligibleClients = async (): Promise<WEFResponse<TowingEligibleClient[]>> => {
  const { data } = await api.get<WEFResponse<TowingEligibleClient[]>>(
    '/TowingNotification/eligible-clients'
  );
  return data;
};

export const previewTowingNotifications = async (
  request: TowingNotificationRequest
): Promise<WEFResponse<TowingNotificationPreview[]>> => {
  const { data } = await api.post<WEFResponse<TowingNotificationPreview[]>>(
    '/TowingNotification/preview-notifications',
    request
  );
  return data;
};

export const sendTowingNotifications = async (
  request: TowingNotificationRequest
): Promise<WEFResponse<SendNotificationsResponse>> => {
  const { data } = await api.post<WEFResponse<SendNotificationsResponse>>(
    '/TowingNotification/send-notifications',
    request
  );
  return data;
};
